import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_thin-plus",
  "use": "svg_thin-plus-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_thin-plus\"><path stroke-width=\"1.2\" stroke=\"currentColor\" d=\"M8.9 0v18M0 8.9h18\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol